import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';
import { EV_OCPP_LINK } from 'evcharging/app/seo/pages';
import FaqSection from 'evcharging/containers/layout/FaqSection';
import StayUpdated from 'evcharging/containers/layout/StayUpdated';
import EndToEnd from 'evcharging/containers/layout/EndToEnd';
import Significance from 'evcharging/containers/ocpp/Significance';
import Interoperability from 'evcharging/containers/ocpp/Interoperability';
import Advantages from 'evcharging/containers/ocpp/Advantages';
import { I18nPage } from 'i18n/types/pages.enum';

const OCPPPage: FC<StaticPageProps> = ({ page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title}
    description={page.meta_description}
  >
    <Navigation />
    <Significance />
    <Interoperability />
    <Advantages />
    <EndToEnd />
    <RequestConsultation />
    <FaqSection faqs={page.faqs} />
    <StayUpdated />
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  EV_OCPP_LINK,
  undefined,
  [I18nPage.EvChargingCommon, I18nPage.EvChargingOcpp, I18nPage.EvChargingCharger, I18nPage.EnergyRates]
);

export default OCPPPage;
